module.exports = __webpack_public_path__ + "img/crash.6d8331a2.jpeg";